module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="compare-board '+
((__t=( is_coach_stats ? 'coach-stats-tab' : '' ))==null?'':_.escape(__t))+
'">\n	';
 _.each(_.range(max_players_size), function(index){
		var player = compare[index] || {};
	
__p+='\n		';
 if(player.id){ 
__p+='\n			<div class="compare-board-item">\n				<div class="compare-board-item-top">\n					<div class="compare-board-item-main">\n						<a\n							class="icon icon-favourite compare-board-item-btn compare-board-item-favourite js-favourite-player '+
((__t=( player.is_favourite ? 'is-favourite' : '' ))==null?'':_.escape(__t))+
'"\n							data-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'"\n							data-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'">\n							<i class="ion-android-star"></i>\n						</a>\n						<div class="figure">\n							<figure>\n								<picture>\n									<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n									<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'" alt="">\n								</picture>\n							</figure>\n						</div>\n						<a class="compare-board-item-btn compare-board-item-remove js-remove-player"\n						   data-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'"\n						   data-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'">\n							<i class="ion-close-round"></i>\n						</a>\n					</div>\n					<div class="compare-board-item-player-name">\n						<i class="player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n						<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n					</div>\n					<div class="compare-board-item-player-positions">\n						<span>'+
((__t=( player.position_names.join(' | ') ))==null?'':_.escape(__t))+
'</span>\n						<span> | </span>\n						<span>'+
((__t=( _.currencyFormat(player.cost, '') ))==null?'':_.escape(__t))+
'</span>\n					</div>\n				</div>\n				<div class="compare-board-item-footer '+
((__t=( colors[index] ))==null?'':_.escape(__t))+
'">\n					<div class="compare-board-item-stats">\n						<p>Played</p>\n						<b>'+
((__t=( player.stats.games_played ))==null?'':_.escape(__t))+
'</b>\n					</div>\n					<div class="compare-board-item-stats middle">\n						<p>Average</p>\n						<b>'+
((__t=( player.stats.avg_points ))==null?'':_.escape(__t))+
'</b>\n					</div>\n					<div class="compare-board-item-stats">\n						<p>Total</p>\n						<b>'+
((__t=( player.stats.total_points ))==null?'':_.escape(__t))+
'</b>\n					</div>\n				</div>\n			</div>\n		';
 } else { 
__p+='\n			<div class="compare-board-item-empty">\n				<i class="icon-plus ion-plus"></i>\n				<span>Add Player</span>\n			</div>\n		';
 } 
__p+='\n	';
 }) 
__p+='\n</div>';
}
return __p;
};
